module.exports = __webpack_public_path__ + "static/greenisland2021_mainvideo_cover-3-f9892c6d3973f128d8295255fd1b75a1.jpg";